export const assignColor = (porcentaje: number): string => {
    let color: string;
    if (porcentaje >= 0 && porcentaje <= 50) {
        color = 'c_red.main'; // rojo
    } else if (porcentaje > 50 && porcentaje <= 75) {
        color = 'c_orange.main'; // naranja
    } else if (porcentaje > 75 && porcentaje < 100) {
        color = 'c_yellow.main'; // amarillo
    } else {
        color = 'c_green.main'; // verde
    }
    return color;
};